import React from 'react'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { PageHeader } from '@components/page-header/PageHeader'

type ErrorHeaderProps = {
  title?: string
}

export const ErrorHeader: React.FC<ErrorHeaderProps> = ({ title }) => {
  const { t } = useAppTranslation({ keyPrefix: 'error-page.header' })

  return <PageHeader title={title ?? t('title')} />
}
